import React, { useEffect } from 'react';
import { useParams, Link, useLocation, Navigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useSound } from '../contexts/SoundContext';
import PageLayout from '../components/PageLayout';
import MapCanvas from '../components/MapCanvas';
import { FIVEFIVE_MAPS } from '../data/5v5Maps';

const FiveFiveMapDetailPage = () => {
  const { mapSlug } = useParams();
  const { t } = useLanguage();
  const { playButtonClick } = useSound();
  const location = useLocation();
  const assetBase = typeof window !== 'undefined' ? window.location.origin : '';

  const map = FIVEFIVE_MAPS.find((m) => m.slug === mapSlug);

  useEffect(() => {
    if (map) {
      document.title = `${map.name} - 5V5 Maps - ${t('app.title')}`;
    }
  }, [map, t, location]);

  if (!map) {
    return <Navigate to="/maps/5v5" replace />;
  }

  return (
    <PageLayout title={map.name} subtitle="5V5 Deathmatch">
      <div className="mt-4">
        <MapCanvas
          slug={`5v5-${map.slug}`}
          imageUrl={`${assetBase}/Maps/5V5/${encodeURIComponent(map.file)}`}
          mapName={map.name}
          backLink={
            <Link
              to="/maps/5v5"
              onClick={playButtonClick}
              className="inline-flex items-center space-x-1 text-sm text-indigo-600 dark:text-[#FF9800] hover:underline"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              <span>All 5V5 Maps</span>
            </Link>
          }
        />
      </div>
    </PageLayout>
  );
};

export default FiveFiveMapDetailPage;
